import { render } from "./NovaRequisicaoMaterialTodos.vue?vue&type=template&id=7cb03e3f&scoped=true"
import script from "./NovaRequisicaoMaterialTodos.vue?vue&type=script&lang=js"
export * from "./NovaRequisicaoMaterialTodos.vue?vue&type=script&lang=js"

import "./NovaRequisicaoMaterialTodos.vue?vue&type=style&index=0&id=7cb03e3f&scoped=true&lang=css"
import "./NovaRequisicaoMaterialTodos.vue?vue&type=style&index=1&id=7cb03e3f&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb03e3f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QInput,QSelect,QField});
